import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OverviewTab from "./Tabs/OverviewTab";
import CredentialsTab from "./Tabs/CredentialsTab";
import InvoiceManagementTab from "./Tabs/InvoiceManagementTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const InvoicesPage = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <MDBox>
        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Invoice Management Service
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Overview" />
            <Tab label="Credentials" />
            <Tab label="Invoice Management" />
          </Tabs>
        </Box>

        {/* Overview Tab */}
        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>

        {/*Credentials Tab */}
        <TabPanel value={tabValue} index={1}>
          <CredentialsTab />
        </TabPanel>

        {/* Invoice Management Tab */}
        <TabPanel value={tabValue} index={2}>
          <InvoiceManagementTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default InvoicesPage;
